import styled from 'styled-components';

export const SStepContainer = styled.div`
  display: inline-block;
`;
export const SStepBox = styled.div<{ completed?: boolean }>(({ theme, completed }) => {
  return `
    height: 33px;
    width: 33px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${completed ? theme.colors.light5 : theme.colors.primaryDark2};
    color: white;
    font-weight: ${theme.font.weight.bold};
    font-size: ${theme.font.size.smallMedium3};
  `;
});
